import styled from 'styled-components';

const PageSliderStyled = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  overflow: hidden;
  transition: transform 0.3s ease-out;
`;

export default PageSliderStyled;
export { PageSliderStyled };
